$(document).ready(function(){

 $(window).scroll(function () {

   if ($(window).width() > 779) {
 
     if($(window).scrollTop() > 200) {
    $(".site-header__logo-image").addClass('sticky');     
    $(".site-nav").addClass('sticky');
  } else {
    $(".site-nav").removeClass('sticky');
          $(".site-header__logo-image").removeClass('sticky');     
  }
  
}
   if($(window).scrollTop() > 80) {
    $(".site-header__logo-image").addClass('sticky');     
    $(".site-nav").addClass('sticky');
     $(".site-header.logo--center").css({'position':'fixed','top':'0px'});
  }
   else{
   $(".site-header.logo--center").css({'position':'relative','top':'unset'});
     $("a.site-header__logo-image.site-header__logo-image--centered.sticky").css({'position':'relative','border':'none','background':'transparent'})
   }
 
 })
   

 $(".pcasub").fadeOut(500);
 $(".SurgicalProcedures").fadeIn(500);

  
$(".pgcat span").click(function(){
$(".pca").removeClass("active");
    $(this).addClass("active");
    var tile=$(this).attr("id");
    $(".pcasub").fadeOut(500);
    $("."+tile).fadeIn(500);
    
})  


  $(".scro").click(function() {
    var sid=$(this).attr('id');
    sid = sid.replace(/^#/, '');
    $('html, body').animate({
        scrollTop: $("."+sid).offset().top
    }, 2000);
});


$('.open-popup-link').magnificPopup({
  type:'inline',
  midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
});




jQuery(".accordion_head").on('click', function() {
    if (jQuery('.accordion_body').is(':visible')) {
      jQuery(".accordion_body").slideUp(300);
      jQuery(".plusminus").text('+');
    }
    if (jQuery(this).next(".accordion_body").is(':visible')) {
      jQuery(this).next(".accordion_body").slideUp(300);
      jQuery(this).children(".plusminus").text('+');
      jQuery(this).removeClass("active");
    } else {
      jQuery(this).next(".accordion_body").slideDown(300);
      jQuery(this).children(".plusminus").text('-');
      jQuery(this).addClass("active");
    }
  });


  

$(".sec2 .menucon li").click(function(){
  
  $(".sec2 .menucon li").removeClass("active");
  $(this).addClass("active");
                       var xx=$(this).attr("data-tab");
$(".ii").css("display", "none");
$("."+xx).css("display", "block");
                       
                       
}) 

$(".sec2 .menucon option").click(function(){
  
  $(".sec2 .menucon option").removeClass("active");
  $(this).addClass("active");
                       var xx=$(this).attr("data-tab");
$(".ii").css("display", "none");
$("."+xx).css("display", "block");
                       
                       
})

$(".pgcatf span").click(function(){

    var sct= $(this).attr("id");
    $(".pca").removeClass("active");
    $(this).addClass("active");
    $(".prcon").hide();
    $("."+sct).show();
    
})



  

   var swiperrr = new Swiper(".mySwiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });


 var swiperyy = new Swiper(".mySwiperyy", {
        slidesPerView: 1,
  spaceBetween: 10,
   
  
  // Responsive breakpoints
   navigation: {
        nextEl: ".pd1",
        prevEl: ".pd2",
      },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 5
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 2,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  }
    });



 var swiperrv = new Swiper(".mySwiperv", {
        slidesPerView: 1,
  spaceBetween: 10,
  // Responsive breakpoints
   navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 1,
      spaceBetween: 40
    }
  }
    });


   var swipersec1 = new Swiper(".mySwipersec1", {
        slidesPerView: 1,
  spaceBetween: 40,
  // Responsive breakpoints
   navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
 
    });

   var swipers4 = new Swiper(".mySwipers4", {
        slidesPerView: 1,
  spaceBetween: 40,
  // Responsive breakpoints
   navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
 
    });


    var swiperrev = new Swiper(".mySwiperev", {
        slidesPerView: 1,
  spaceBetween: 40,
  // Responsive breakpoints
      
   navigation: {
        nextEl: ".swn1",
        prevEl: ".swn2",
      },
 
    });

  


   var swipererp = new Swiper(".mySwiperp", {
      slidesPerView: 1.8,
     spaceBetween: 10,
      centeredSlides: false,
     
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
       breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    // when window width is >= 640px
    768: {
      slidesPerView: 1.8,
      spaceBetween: 40
    }
  },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
     
    });


$(".sec2conx .menucon li").click(function(){
  $(".sec2conx .menucon li").removeClass("active");
  $(this).addClass("active");
    var x=$(this).attr("id");
   var swiperyy = new Swiper(".mySwiperyy");
 swiperyy.destroy();
    $(".tt").hide();
    $("."+x).show();
})
  

$(".colc").click(function(){
  var dt=$(this).attr("data-id");
   $(this).closest(".hmc").find(".colc").removeClass("active");
  $(this).addClass("active");
  
  console.log(dt);
  $(this).closest(".hmc").find(".hmprodx").hide();
  $(this).closest(".hmc").find("."+dt).show()
 
})


jQuery(".r1 svg").click(function(){
jQuery(".r1").hide();
jQuery(".r2").show();

jQuery(".s1 .cls-1").css("opacity",".7");
jQuery(".s2 .cls-1").css("opacity","1");

})


jQuery(".r2 svg").click(function(){
jQuery(".r2").hide();
jQuery(".r3").show();

jQuery(".s2 .cls-1").css("opacity",".7");
jQuery(".s3 .cls-1").css("opacity","1");

})


jQuery(".r3 svg").click(function(){
jQuery(".r3").hide();
jQuery(".r4").show();
jQuery(".s3 .cls-1").css("opacity",".7");
jQuery("svg#Capa_1").css("fill","white");

})



// if($.urlParam('contact_posted')){

// if($.urlParam('contact_posted')=='true'){
//   $(".s5lin").html("<p style='color:white;font-size:22px;'>Thank you for completing our quiz! A member from our team will reach out to you shortly.</p>");

// }
// }
var urlParams = new URLSearchParams(window.location.search); //get all parameters
var foo = urlParams.get('contact_posted'); //extract the foo parameter - this will return NULL if foo isn't a parameter

if(foo=="true") { //check if foo parameter is set to anything
   $(".s5lin").html("<p style='color:white;font-size:22px;'>Thank you for completing our quiz!<br>A member from our team will reach out to you shortly.</p><br><br><br>");

}


var qz=0;
jQuery(".qz").click(function(){
  qz=qz+1;
  console.log(qz);
  
  jQuery(".ifa").hide();
  if(qz==11){
  jQuery(".ifm").html("Thank you.");
   
  }
  
  jQuery(".fprog svg").css("opacity","1");
  jQuery(".s"+qz+" svg").css("opacity",".5");
if(jQuery(this).hasClass("active")){
jQuery(this).css("color","white");
jQuery(this).css("background","transparent");
jQuery(this).removeClass("active");
}else{
jQuery(this).css("color","black");
jQuery(this).css("background","white");
jQuery(this).addClass("active");
}
  
  if(jQuery(this).attr('id')=='male'){
    jQuery(".s5lb").hide();
  jQuery(".maleq").show();
    
    
  }else if(jQuery(this).attr('id')=='female'){
    jQuery(".s5lb").hide();
    jQuery(".femaleq").show();
  
  
  }else{
  
  jQuery(this).closest(".s5lbb").hide();
    jQuery(this).closest(".s5lbb").next(".s5lbb").show();
  
  
  
  }
  
  
  
  

})            
            
jQuery(".gmy").click(function(){
jQuery(".s5l").fadeOut();
jQuery(".s5proxy").fadeIn(2000);

})    




    $('.sec1imgcon_x').slick({
    lazyLoad: 'onDemand',
    centerMode: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows:true,
       prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'></button>",
    responsive: [
    {
      breakpoint: 768,
      settings: {
      slidesToShow: 1,
      centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
      slidesToScroll: 1
      }
    }
   ]
    });


  jQuery(".top_bar").hover(
				
               function () {
                 jQuery(".top-warning").show();
               }, 
				
               function () {
                  jQuery(".top-warning").hide();
               }
            );



 $('.beefup').beefup(); 
  
  
  
    $('.prslid').slick({
    lazyLoad: 'onDemand',
    centerMode: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows:true,
       prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'></button>",
    responsive: [
    {
      breakpoint: 768,
      settings: {
      slidesToShow: 1,
      centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
      slidesToScroll: 1
      }
    }
   ]
  });
 
  $('.fqp').slick({
    lazyLoad: 'onDemand',
    centerMode: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows:true,
       prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'></button>",
    responsive: [
    {
      breakpoint: 768,
      settings: {
      slidesToShow: 1,
      centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
      slidesToScroll: 1
      }
    }
   ]
  });
  
  $(".cpc").click(function(){
  
  $(".footer-last").hide();
})
  
  
  
  
    if ($.cookie('noShowWelcome')) $('.footer-last').hide();
    else {
        $(".footer-last").click(function() {
            $(".footer-last").fadeOut(1000);
            $.cookie('noShowWelcome', true);    
        });
    }
  
  
  
  
  
  
  

$('.n1').on('click', function() {
  $.smoothScroll({
    offset:-80,
    scrollTarget: '#shopify-section-procedure2'
  });
  return false;
});
$('.n2').on('click', function() {
  $.smoothScroll({
    offset:-80,
    scrollTarget: '.lsabr'
  });
  return false;
});


$('.n3').on('click', function() {
  $.smoothScroll({
    offset:-80,
    scrollTarget: '#shopify-section-procedure3'
  });
  return false;
});


$('.n4').on('click', function() {
  $.smoothScroll({
    offset:-150,
    scrollTarget: '.ls2con'
  });
  return false;
});

$('.n5').on('click', function() {
  $.smoothScroll({
    
    scrollTarget: '#shopify-section-procedure4'
  });
  return false;
});

  
  
  $('.mfp').magnificPopup({
  items: {
      src: '<div class="white-popup">The product that you\'ve selected is available by prescription only. To request a consultation to see if this product is right for you and to obtain a prescription, please <b><a href="/pages/contact">contact us</a></b>.</div>',
      type: 'inline'
  },
  closeBtnInside: true
});

  
  
  
  


$(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".contentx")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".contentx").slideUp(200);
      $(this)
        .siblings(".contentx")
        .slideDown(200);
    }
  });

  
  
  
})

$.urlParam = function(name){
    var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    return results[1] || 0;
}